import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CncMachining.css';

const CncMachining = () => {
    const [activeFaq, setActiveFaq] = useState(0);
    const navigate = useNavigate();
    const goToContact = () => navigate('/contact', { state: { scrollToForm: true } });

    const faqs = [
        {
            q: "What industries do you serve?",
            a: "We support manufacturing and engineering industries including automotive components, industrial equipment, machinery parts, and custom engineering applications. Our CNC machining services are tailored to meet diverse industrial requirements."
        },
        {
            q: "Do you offer customized CNC machining solutions?",
            a: "Yes. We provide fully customized CNC machining based on client drawings, specifications, and material requirements. We handle both prototype and bulk production orders with precision."
        },
        {
            q: "What materials do you work with?",
            a: "We machine a variety of engineering materials including mild steel, stainless steel, aluminum, brass, and other industrial metals depending on project requirements."
        },
        {
            q: "How can I get a quotation?",
            a: "You can request a quote by sharing your technical drawings, material details, quantity requirements, and delivery timeline through our contact form or by contacting us directly."
        },
        {
            q: "How do you ensure quality control?",
            a: "All machined components undergo dimensional verification and inspection before dispatch. We follow strict tolerance standards and systematic machining procedures to maintain consistent quality."
        }
    ];

    return (
        <div className="cnc-machining-page">
            {/* Hero Section */}
            <section className="cnc-hero">
                <div className="container">
                    <h1 className="fade-in">Precision CNC Machining Services</h1>
                </div>
            </section>

            {/* About CNC section */}
            <section className="cnc-about-section section-padding">
                <div className="container">

                    <div className="cnc-about-header">
                        <div className="cnc-about-title-group">
                            <div className="cnc-icon-wrapper">
                                <img src="https://sakthivel.ascentbw.com/Files/About/About1.png" alt="CNC Icon" />
                            </div>
                            <h2>About Our CNC Machining</h2>
                        </div>

                        <div className="cnc-about-header-split">
                            <div className="cnc-about-header-text">
                                <p>Sakthivel Engineering specializes in precision CNC machining for industrial metal components. We deliver high-accuracy production with tight tolerances and consistent quality control.</p>
                            </div>
                            <div className="cnc-about-header-btn">
                                <button className="btn-primary" onClick={goToContact}>Request a Quote</button>
                            </div>
                        </div>
                    </div>

                    <div className="cnc-capabilities-group">
                        <div className="cnc-capability-block">
                            <h3>Our CNC Machining Capabilities</h3>
                            <p>Sakthivel Engineering provides high-precision CNC machining services for industrial metal components. Our advanced machining processes ensure dimensional accuracy, tight tolerances, and superior surface finish for both prototype and production runs.</p>
                            <p>We work with a variety of engineering materials and deliver reliable machining solutions tailored to client specifications.</p>
                        </div>

                        <div className="cnc-capability-block mt-40">
                            <h3>Our CNC Machining Services Include</h3>
                            <p>We offer a comprehensive range of CNC machining solutions to meet diverse industrial requirements:</p>
                        </div>
                    </div>

                    <div className="cnc-about-img mt-40">
                        <img src="https://sakthivel.ascentbw.com/Files/Service/Sub1.png" alt="CNC Machining Process" />
                    </div>

                    <div className="cnc-quality-block mt-40">
                        <h3>Quality & Process Control</h3>
                        <p className="mt-20">At Sakthivel Engineering, we follow systematic machining and inspection procedures to maintain consistent quality standards across all projects.</p>
                        <ul className="cnc-quality-list mt-20">
                            <li>Dimensional accuracy verification</li>
                            <li>Strict tolerance adherence</li>
                        </ul>
                    </div>

                </div>
            </section>

            {/* Process Section */}
            <section className="cnc-process-section section-padding bg-light">
                <div className="container">
                    <h2 className="section-title text-center mb-50">Our CNC Machining Process</h2>

                    <div className="process-grid">
                        <div className="process-card">
                            <div className="process-num">01</div>
                            <h5 className="process-accent">Requirement Review</h5>
                            <h4>Requirement Analysis &<br />Planning</h4>
                            <p>We begin by reviewing client drawings, specifications, and material requirements. Our team evaluates machining feasibility, tolerances, and production timelines before initiating the process.</p>
                        </div>
                        <div className="process-card">
                            <div className="process-num">02</div>
                            <h5 className="process-accent">Machining Process</h5>
                            <h4>Precision CNC<br />Machining</h4>
                            <p>Using advanced CNC machines, we carry out accurate turning, milling, and cutting operations. Each component is produced with strict adherence to dimensional tolerances and surface finish requirements.</p>
                        </div>
                        <div className="process-card">
                            <div className="process-num">03</div>
                            <h5 className="process-accent">Quality & Delivery</h5>
                            <h4>Requirement Analysis &<br />Planning</h4>
                            <p>Every finished component undergoes dimensional verification and quality checks before dispatch. We ensure timely delivery and consistent production standards for all orders.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ & Split Section */}
            <section className="cnc-faq-section section-padding bg-light pt-0">
                <div className="container">
                    <div className="cnc-faq-split">

                        <div className="cnc-faq-left">
                            <h5 className="faq-accent">FAQ</h5>
                            <h2 className="section-title text-left">Frequently Asked<br />Questions</h2>
                            <p>Find answers to common questions about our CNC machining services, capabilities, and production process.</p>
                            <button className="btn-primary mt-30" onClick={goToContact}>Request a Quote</button>
                        </div>

                        <div className="cnc-faq-right">
                            <div className="cnc-faq-grid">
                                {faqs.map((faq, idx) => (
                                    <div
                                        key={idx}
                                        className={`cnc-faq-item ${activeFaq === idx ? 'active' : ''}`}
                                        onClick={() => setActiveFaq(activeFaq === idx ? null : idx)}
                                    >
                                        <div className="cnc-faq-header">
                                            <h4>{faq.q}</h4>
                                            <span className="toggle-icon1"></span>
                                        </div>
                                        <div className="cnc-faq-body">
                                            <p>{faq.a}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cnc-cta-section">
                <div className="container text-center">
                    <h2>Need Precision CNC<br />Machining Services?</h2>
                    <p>Share your drawings and specifications with us. Our team will review your requirements and<br />provide a competitive quotation with accurate production timelines.</p>
                    <button className="btn-light mt-30" onClick={goToContact}>Request a CNC Quote</button>
                </div>
            </section>
        </div>
    );
};

export default CncMachining;
